import duckBanGif from "../assets/utya-ban.gif";

export default function ErrorScreen({ message }: { message: string }) {
  if (isAccessPendingMessage(message)) {
    return <AccessPendingScreen />;
  }

  return (
    <div className="flex h-screen items-center justify-center p-6 text-center">
      <div className="tp-card max-w-sm space-y-3">
        <p className="text-lg font-semibold">что-то пошло не так</p>
        <p className="text-hint text-sm">{message}</p>
        <button
          onClick={() => window.location.reload()}
          className="tp-button-primary mt-2 w-full"
        >
          перезагрузить
        </button>
      </div>
    </div>
  );
}

function AccessPendingScreen() {
  return (
    <div className="tp-access-pending-screen">
      <div className="tp-access-pending-content">
        <img
          src={duckBanGif}
          alt=""
          aria-hidden="true"
          className="tp-access-pending-duck"
          draggable={false}
        />
        <h1 className="tp-access-pending-title">доступ запрещен</h1>
        <p className="tp-access-pending-text">
          ваша заявка отправлена администратору, ожидайте подтверждения
        </p>
      </div>
    </div>
  );
}

function isAccessPendingMessage(message: string): boolean {
  const normalized = message.toLowerCase();
  return (
    normalized.includes("заявка") && normalized.includes("одобрен")
  ) || normalized.includes("доступ к этому разделу не подтверждён");
}
